import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { pxToRem } from "@vfit/shared/themes";
import { svgObj } from "./svgObj";
/**
 * Suggest: use only one between width and height
 * to set the svg's dimensions
 */ /**
 * Svg component.
 * SUGGEST: use only one between width and height
 * to set the svg's dimensions
 * @param name (mandatory)
 * @returns
 */ export var Svg = function(_param) {
    var name = _param.name, _color = _param.color, color = _color === void 0 ? "#0d0d0d" : _color, _secondColor = _param.secondColor, secondColor = _secondColor === void 0 ? "#e60000" : _secondColor, height = _param.height, width = _param.width, shrinkable = _param.shrinkable, rest = _object_without_properties(_param, [
        "name",
        "color",
        "secondColor",
        "height",
        "width",
        "shrinkable"
    ]);
    var El = svgObj[name];
    var h = height !== undefined ? pxToRem(height) : undefined;
    var w = width !== undefined ? pxToRem(width) : undefined;
    return /*#__PURE__*/ _jsx(El, _object_spread({
        color: color,
        secondColor: secondColor,
        height: h,
        width: w,
        shrinkable: shrinkable
    }, rest));
};
